export const supportedFileExtensions = [
  '.3mf',
  '.dxf',
  '.obj',
  '.mpp',
  '.mxp',
  '.stl',
  '.stp',
  '.step',
]

export const supportedFileExtensionsHtmlAccept = supportedFileExtensions.join(',')
